// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__BKY2-","content":"styles_content__bWaco"};